/**
 * This is a wrapper component for different Layouts.
 * Navigational 'aside' content should be added to this wrapper.
 */
import React from 'react';
import { node, number, string, shape } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage } from '../../util/reactIntl';
import { withViewport } from '../../util/contextHelpers';
import { LayoutWrapperSideNav } from '../../components';

const MAX_HORIZONTAL_NAV_SCREEN_WIDTH = 1023;

const scrollToTab = currentTab => {
  const el = document.querySelector(`#${currentTab}Tab`);

  if (el) {
    el.scrollIntoView({
      block: 'end',
      inline: 'end',
      behavior: 'smooth',
    });
  }
};

const LayoutWrapperAccountSettingsSideNavComponent = props => {
  const { currentTab, viewport, currentUser } = props;

  let hasScrolledToTab = false;

  const { width } = viewport;
  const hasViewport = width > 0;
  const hasHorizontalTabLayout = hasViewport && width <= MAX_HORIZONTAL_NAV_SCREEN_WIDTH;
  const hasVerticalTabLayout = hasViewport && width > MAX_HORIZONTAL_NAV_SCREEN_WIDTH;
  const hasFontsLoaded = hasViewport && document.documentElement.classList.contains('fontsLoaded');

  if (hasVerticalTabLayout) {
    hasScrolledToTab = true;
  } else if (hasHorizontalTabLayout && !hasScrolledToTab && hasFontsLoaded) {
    scrollToTab(currentTab);
    hasScrolledToTab = true;
  }

  const accountRole =
    currentUser &&
    currentUser.attributes.profile.publicData &&
    currentUser.attributes.profile.publicData.account_role;

  const isSeller =
    typeof accountRole === 'string' && ['freelancer', 'light-entrepreneur'].includes(accountRole);
  const isFreelancer = accountRole === 'freelancer';
  const isCustomer = accountRole === 'customer';

  const tabs = [
    {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.accountTabTitle" />,
      selected: currentTab === 'AccountSettingsPage',
      id: 'AccountSettingsPageTab',
      linkProps: {
        name: 'AccountSettingsPage',
      },
    },
  ];

  if (currentUser && isSeller) {
    tabs.push({
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.taxInformationTabTitle" />,
      selected: currentTab === 'TaxInformationPage',
      id: 'TaxInformationPageTab',
      linkProps: {
        name: 'TaxInformationPage',
      },
    });
  }

  if (currentUser && isFreelancer) {
    tabs.push({
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentsTabTitle" />,
      selected: currentTab === 'StripePayoutPage',
      id: 'StripePayoutPageTab',
      linkProps: {
        name: 'StripePayoutPage',
      },
    });
  }

  if (currentUser && isCustomer) {
    tabs.push({
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.billingTabTitle" />,
      selected: currentTab === 'BillingPage',
      id: 'BillingPageTab',
      linkProps: { name: 'BillingPage' },
    });
  }

  return <LayoutWrapperSideNav tabs={tabs} />;
};

LayoutWrapperAccountSettingsSideNavComponent.defaultProps = {
  className: null,
  rootClassName: null,
  children: null,
  currentTab: null,
};

LayoutWrapperAccountSettingsSideNavComponent.propTypes = {
  children: node,
  className: string,
  rootClassName: string,
  currentTab: string,

  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,
};

const LayoutWrapperAccountSettingsSideNav = compose(withViewport)(
  LayoutWrapperAccountSettingsSideNavComponent
);

export default LayoutWrapperAccountSettingsSideNav;
